
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/technicalOffice",
      function () {
        return require("private-next-pages/[lang]/technicalOffice.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lang]/technicalOffice"])
      });
    }
  